const MOBILE_BREAKPOINT = "(max-width: 749px)";
const mobileMediaQuery = window.matchMedia(MOBILE_BREAKPOINT);

function handleBreadcrumbClick(event) {
  event.preventDefault();
  event.currentTarget.classList.toggle("is-expanded");
}

function bindBreadcrumbToggle(item) {
  item.addEventListener("click", handleBreadcrumbClick);
}

function unbindBreadcrumbToggle(item) {
  item.removeEventListener("click", handleBreadcrumbClick);
  item.classList.remove("is-expanded"); // reset state so desktop layout isn't left mid-toggle
}

function syncBreadcrumbBehavior(isMobile) {
  document.querySelectorAll(".breadcrumb__collection").forEach((item) => {
    isMobile ? bindBreadcrumbToggle(item) : unbindBreadcrumbToggle(item);
  });
}

// Initial bind on load
syncBreadcrumbBehavior(mobileMediaQuery.matches);

// Re-bind/unbind on breakpoint crossing (resize, rotation, devtools responsive mode)
mobileMediaQuery.addEventListener("change", (event) => {
  syncBreadcrumbBehavior(event.matches);
});